import { Component, OnInit } from '@angular/core';
import { TreeviewConfig, TreeviewItem} from 'ngx-treeview';
import { PermissionService } from '../../services/permission.service';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router} from '@angular/router';
import { PermissionDto } from '../../dto/permission.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseService } from '../../base.service';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: [],
  providers: [
    PermissionService
  ]
})
export class PermissionComponent implements OnInit {

    title_component: string;
    title_panel: string;
    links: any;
    items: TreeviewItem[];
    values: number[];
    message: string;
    selected = false;
    id_role: number;
    data_one = [];
    cant: number;
    vez = 0;
    normal1 = 0;
    normal2 = 0;
    multi1 = 0;
    multi2 = 0;
    config = TreeviewConfig.create({
        hasAllCheckBox: false,
        hasFilter: false,
        hasCollapseExpand: false,
        decoupleChildFromParent: false,
        maxHeight: 400
    });

    public loading = false;

    constructor(
        private permissionService: PermissionService,
        private location: Location,
        private toastr: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
        private baseService: BaseService
    ) { }

    ngOnInit() {
      this.title_component = 'Asignar Permisos';
      this.baseService.changedComponentName(this.title_component);
      this.title_panel = 'Asignar permisos';

      this.id_role = +this.route.snapshot.paramMap.get('id');
      this.permissionService.getAll(this.id_role).subscribe(data => {
        let children = [];
        const tree_view = [];

        data.forEach((access) => {
          if (access.systemOption.parentId === null) {
            data.forEach(child => {
              if (child.systemOption.parentId === access.systemOption.id) {
                children.push({text: child.systemOption.name, value: child.id, checked: child.status});
              }
            });

            tree_view.push(new TreeviewItem({text: access.systemOption.name, value: access.id,
              checked: access.status, children: children}));

            children = [];
          }
        });

        this.items = tree_view;
      });
    }

    public onSelectedChange(event) {
      let missing = [];
      let id = null;
      const message = 'Se actualizado el permiso correctamente.';

      if (this.vez > 0){
        if ( this.data_one.length === 0 && event.length === 0) {

          if (event.length === 0) {
            this.data_one = event;
            this.cant = event.length;
          } else {
            if (event.length === 1) {
              this.normal1 += 1;
              id = event[0];
            }

            if (event.length > 1) {
              this.multi1 += 1;
              id = event[0] - 1 ;
            }
            this.data_one = event;
            this.cant = event.length;
          }

          if (id != null) {
            const dto = new PermissionDto(id);
            this.loading = true;
            this.permissionService.update(dto).subscribe(
              data => {
                setTimeout(() => {
                  this.loading = false;
                  this.showSuccess(message);
                }, 1000);
              },
              (err: HttpErrorResponse) => {
                if (err.statusText === 'OK') {
                  this.loading = false;
                  this.showSuccess(message);
                }
              }
            );
          }
        } else {
          missing = event.filter(item => this.data_one.indexOf(item) < 0);
          if (missing.length === 0) {
            missing = this.data_one.filter(item => event.indexOf(item) < 0);
          }

          this.cant = this.data_one.length;

          if ( (this.cant - event.length) === 1 || (this.cant - event.length) === -1) {
            this.normal2 += 1;
            id = missing[0];
          } else {
            id = missing[0] - 1;
            this.multi2 += 1;
          }
          this.data_one = event;

          if (id != null) {
            const dto = new PermissionDto(id);
            this.loading = true;
            this.permissionService.update(dto).subscribe(
              data => {
                setTimeout(() => {
                  this.loading = false;
                  this.showSuccess(message);
                }, 1000);
              },
              (err: HttpErrorResponse) => {
                if (err.statusText === 'OK') {
                  this.loading = false;
                  this.showSuccess(message);
                }
              }
            );
          }

        }
      } else{
        this.data_one = event;
        this.cant = event.length;
        this.vez += 1;
      }
    }

    showSuccess(message: string): void {
      this.toastr.success(message, 'Éxito!', {
        timeOut: 6000,
        positionClass: 'toast-top-right'
      });
    }

    goBack(event): any {
      this.location.back();
    }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/permission/permission.component.ts